export const ISetSIDTokenUseCaseType = Symbol('ISetSIDTokenUseCase');
